import { MarketType } from 'constants/markets';
import { Menu } from 'generated/graphql';
import { useEffect } from 'react';
import { isRenderingOnServer } from 'server/isRenderingOnServer';
import useLayout from 'stores/useLayout';
import useMarket from 'stores/useMarket';

type UpdatePageStateProps = {
    market: MarketType;
    menu: Menu;
    footerContent: string;
    title: string;
};

export default function useSetGlobalState(props: UpdatePageStateProps) {
    const { market, menu, footerContent } = props ?? { market: null, menu: null, footerContent: null };
    const setMarket = useMarket((state) => state.setMarket);
    const setLayout = useLayout((state) => state.setLayoutState);

    if (isRenderingOnServer() && market) {
        setMarket(market);
    }

    useEffect(() => {
        if (!market) {
            return;
        }
        setMarket(market);
    }, [market, setMarket]);

    useEffect(() => {
        if (!menu) {
            return;
        }
        setLayout(menu.items, footerContent);
    }, [menu, footerContent, setLayout]);
}
